<template>
  <div>
    <div class="fm-flex">
      <el-input
        :value="getSelectLabel"
        placeholder="请选择用户"
        readonly
      ></el-input>
      <el-button
        type="primary"
        class="fm-margin-left-10"
        @click="showPopover = true"
        >选择</el-button
      >
    </div>
    <el-dialog
      title="选择用户"
      append-to-body
      modal-append-to-body
      width="800px"
      :visible.sync="showPopover"
      close-on-click-modal
      close-on-press-escape
    >
      <el-form inline :model="searchData">
        <el-form-item>
          <el-input
            placeholder="姓名/手机号/邮箱"
            clearable
            prefix-icon="el-icon-search"
            v-model="searchData.searchInputValue"
            style="width: 250px"
            @keyup.enter.native="changeAndSearch"
          >
          </el-input>
        </el-form-item>
        <el-form-item label="用户类型">
          <EnumSelect
            enumName="UserTypeEnum"
            :multiple="false"
            placeholder="请选择用户类型"
            v-model="searchData.userTypeEnum"
            @change="changeAndSearch"
          ></EnumSelect>
        </el-form-item>
        <el-form-item>
          <el-button
            icon="el-icon-search"
            type="primary"
            size="mini"
            @click="changeAndSearch"
            :loading="searchLoading"
          >
            查询
          </el-button>
          <el-button
            icon="el-icon-refresh"
            size="mini"
            @click="resetAndSearch"
            :loading="searchLoading"
          >
            重置
          </el-button>
        </el-form-item>
      </el-form>
      <el-table
        v-loading="searchLoading"
        :data="searchRes && searchRes.data ? searchRes.data : []"
        stripe
        :row-key="
          (row) => {
            return row.id + row.lastEditTime;
          }
        "
        ref="refsTable"
        @sort-change="sortChange"
        max-height="400px"
      >
        <el-table-column
          prop="phoneNumber"
          label="账号"
          width="200"
          align="center"
          header-align="center"
          sortable="custom"
        >
        </el-table-column>
        <el-table-column
          prop="name"
          label="姓名"
          width="200"
          align="left"
          header-align="center"
          sortable="custom"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <el-tag type="success" v-if="scope.row.userTypeEnum.Name == 'Boss'"
              >老板</el-tag
            >
            {{ scope.row.name }}
          </template>
        </el-table-column>
        <el-table-column
          fixed="right"
          label="操作"
          header-align="center"
          align="center"
          width="100"
        >
          <template slot-scope="scope">
            <el-button
              @click.native.stop="select(scope.row)"
              type="text"
              icon="el-icon-edit"
            >
              选择
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "Fmerpv2WebUserSelect",
  props: {
    value: {
      type: Object,
      default() {
        return null;
      },
    },
  },
  computed: {
    getSelectLabel() {
      if (this.value && this.value.name) {
        return this.value.name;
      }
    },
  },
  watch: {
    showPopover: {
      handler(newVal, val) {
        if (newVal) {
          this.search(true);
        }
      },
      immediate: true,
    },
  },
  data() {
    return {
      showPopover: false,

      searchLoading: false,
      searchData: {
        searchInputValue: null,
        userTypeEnum: null,
      },

      searchParam: {
        quickSearchInfoList: [
          {
            columns: ["name", "phoneNumber"],
            quickSearchValue: null,
          },
        ],
        userTypeEnum: null,
        pageInfo: {
          page: 1,
          pageSize: 20,
        },
        sortInfo: null,
      },
      searchRes: {},
    };
  },

  mounted() {},

  methods: {
    select(item) {
      this.$emit("select", item);
      this.showPopover = false;
    },
    handleSizeChange(val) {
      this.searchParam.pageInfo.pageSize = val;
      this.search(true, {
        showSuccessMessage: true,
      });
    },
    handleCurrentChange(val) {
      this.searchParam.pageInfo.page = val;
      this.search(false, {
        showSuccessMessage: true,
      });
    },
    changeAndSearch() {
      this.searchParam.quickSearchInfoList[0].quickSearchValue =
        this.searchData.searchInputValue;
      this.searchParam.userTypeEnum = this.searchData.userTypeEnum;
      this.search(true, {
        showSuccessMessage: true,
      });
    },
    resetAndSearch() {
      this.searchData = this.$options.data().searchData;
      this.changeAndSearch();
    },
    sortChange(val) {
      this.searchParam.sortInfo =
        val && val.order
          ? {
              columnName: val.prop,
              order: val.order.replace("ending", "").toUpperCase(),
            }
          : null;
      this.search(true, {
        showSuccessMessage: true,
      });
    },
    async search(init, args) {
      this.searchLoading = true;
      if (init) {
        this.searchParam.pageInfo.page = 1;
      }
      let requestRes = await this.$api.user_findPageForSelect(
        this.searchParam,
        args
      );
      if (requestRes && requestRes.success) {
        this.searchRes = requestRes;
        this.searchRes.pageInfo = requestRes.pageInfo;
        this.$nextTick(() => {
          if (this.$refs.refsTable) {
            this.$refs.refsTable.doLayout();
          }
        });
      }
      if (requestRes.pageCount == 0) {
        this.searchRes = null;
      }
      setTimeout(() => {
        this.searchLoading = false;
      }, 200);
    },
  },
};
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/UserSelect.vue